import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=15fd78f0&scoped=true&"
import script from "./PersonalData.vue?vue&type=script&lang=js&"
export * from "./PersonalData.vue?vue&type=script&lang=js&"
import style0 from "./PersonalData.vue?vue&type=style&index=0&id=15fd78f0&scoped=true&scss=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fd78f0",
  null
  
)

export default component.exports
import {QForm,QItemLabel,QField,QOptionGroup,QBtn,QTooltip,QInput,QSeparator,QSelect,QItem,QItemSection,QCheckbox} from 'quasar'
component.options.components = Object.assign({QForm,QItemLabel,QField,QOptionGroup,QBtn,QTooltip,QInput,QSeparator,QSelect,QItem,QItemSection,QCheckbox}, component.options.components || {})
